import { withStylePrefix } from '../common/withStylePrefix';
import { ChatInputComponent, chatInputTemplate } from './ChatInput';
import styles from './ChatInput.styles.scss';
export const chatInputDefinition = {
    baseName: 'chat-input',
    template: chatInputTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonChatInput = ChatInputComponent.compose(chatInputDefinition);
